<div class="p-grid banner-management-banner">
	<div class="p-col-12 banner-main-section manage-product-section ">
		<div class="card">
			<h3>Academy Demo Request</h3>
			<p-toolbar styleClass="p-mb-4">
				<ng-template pTemplate="left">
					<!-- <button pButton pRipple label="Add Sponsor" title="Add New Sponsor" icon="pi pi-plus"
						class="p-button-success p-mr-2 p-mb-2" (click)="addNewSponsors()"></button> -->
					<button pButton label="Clear Filters" title="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2"
						icon="pi pi-filter-slash" (click)="clear()"></button>
				</ng-template>

				<ng-template pTemplate="right">
					<button pButton pRipple label="Export" icon="pi pi-file-excel" (click)="exportExcel()"
						class="p-button-help mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
				</ng-template>
			</p-toolbar>

			<div class="card date-filter">
				<div class="p-fluid p-formgrid p-grid align-items-end">
					<div class="p-field p-col-2">
						<label for="searchfield">Select Field</label>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
							placeholder="Select Field" optionLabel="label"></p-dropdown>
					</div>
					<div class="p-field p-col-2">
						<label for="startdt">Start Date</label>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
							[showIcon]="true"></p-calendar>
					</div>
					<div class="p-field p-col-2">
						<label for="enddt">End Date</label>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
							[showIcon]="true"></p-calendar>
					</div>
					<div class="p-field p-col-1">
						<button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-"
							(click)="loadAcademyDemoRequestList(lastTableLazyLoadEvent)"></button>
					</div>
				</div>
			</div>

			<p-table class="expandable" #dt [value]="academyDemoRequestData" [paginator]="true" [rows]="10" [lazy]="true"
				scrollHeight="auto" scrollDirection="both"
				(onLazyLoad)="loadAcademyDemoRequestList($event)" [totalRecords]="totalAcademyDemoRequestDataCount"
				[loading]="loading" [rowsPerPageOptions]="paginationOption"
				styleClass="p-datatable-gridlines p-datatable-striped w-100">
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="player" class="col-180 playerTD">
							<div class="p-d-flex p-jc-between p-ai-center">
								Player
								<p-sortIcon field="player"></p-sortIcon>
							</div>
						</th>
						<!-- <th pSortableColumn="photo" class="col-180 statusTD">
							<div class="p-d-flex p-jc-between p-ai-center">
								Photo
							</div>
						</th> -->
						<th pSortableColumn="Comment" class="col-180 createdDateTD">
							<div class="p-d-flex p-jc-between p-ai-center">
								Comment
								<p-sortIcon field="Comment"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="status">
							<div class="col-150 p-d-flex p-jc-between p-ai-center">
								Status
								<p-sortIcon field="status"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="created_at">
							<div class="p-d-flex p-jc-between p-ai-center">
								Date of Creation
								<p-sortIcon field="created_at"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="createdBy" class="col-180 CreatedByTD">
							<div class="p-d-flex p-jc-between p-ai-center">
								Created By
								<p-sortIcon field="createdBy"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="updated_at" class="col-180 updatedTD">
							<div class="p-d-flex p-jc-between p-ai-center">
								Last Modified On
								<p-sortIcon field="updated_at"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="updatedBy" class="col-180 ModifiedbyTD">
							<div class="p-d-flex p-jc-between p-ai-center">
								Modified By
								<p-sortIcon field="updatedBy"></p-sortIcon>
							</div>
						</th>
						<th class="col-180 actionTD">Action</th>
					</tr>
					<tr>
						<th [ngSwitch]="title">
							<input pInputText type="text"
								(keyup.enter)="dt.filter($event.target.value, 'title', 'contains')" style="width: 100%;"
								[value]="dt.filters['title'] ? dt.filters['title'].value : ''" />
						</th>
					
						<th [ngSwitch]="link">
						</th>

						<th [ngSwitch]="status">
							<p-dropdown #pDropDownId [options]="statuses"
								(onChange)="dt.filter($event.value, 'status', 'equals')" styleClass="p-column-filter"
								placeholder="Select Status" [showClear]="true">
								<ng-template let-option pTemplate="item">
									<span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
								</ng-template>
							</p-dropdown>
						</th>
						<th [ngSwitch]="created_at">
						</th>
						<th [ngSwitch]="createdBy">
							<input pInputText type="text"
								(keyup.enter)="dt.filter($event.target.value, 'createdBy', 'contains')"
								style="width: 100%;"
								[value]="dt.filters['createdBy'] ? dt.filters['createdBy'].value : ''" />
						</th>
						<th [ngSwitch]="updated_at">
						</th>
						<th [ngSwitch]="updatedBy">
							<input pInputText type="text"
								(keyup.enter)="dt.filter($event.target.value, 'updatedBy', 'contains')"
								style="width: 100%;"
								[value]="dt.filters['updatedBy'] ? dt.filters['updatedBy'].value : ''" />
						</th>

						<th>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-academyDemoData let-rowIndex="rowIndex">
					<pre> {{ sponsorsData | json }}</pre>
					<tr>
						<td class="col-180 titleTD">
							{{academyDemoData.player}} 
						</td>

						<!-- <td>
							<img [src]="sponsorsData.photo" alt="Image not available" style="width: 100px; height: 100px;" />
						</td> -->

						<td class="col-200 YoutubeTD">
							<span>{{academyDemoData.comment}}</span>
						</td>

						<td class="col-150 statusTD">
							<p-inputSwitch [(ngModel)]="academyDemoData.status"
								(onChange)="changeStatus(academyDemoData)"></p-inputSwitch>
						</td>

						<td class="col-180 createdDateTD">
							{{academyDemoData.created_at | date: 'dd/MM/yyyy'}}
						</td>

						<td class="col-180 CreatedByTD">
							{{academyDemoData.created_by}}  
						</td>

						<td class="col-180 updatedTD">
							{{academyDemoData.updated_at | date: 'dd/MM/yyyy'}}
						</td>
						<td class="col-180 ModifiedbyTD">
							{{academyDemoData.updated_by}}
						</td>

						
						<td class="text-nowrap p-element p-frozen-column" pfrozencolumn="" alignfrozen="right"
							style="width: 200px; right: 0px;">
							<!-- <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-success p-mr-2" (click)="viewseller(seller.id)"></button> -->
							<!-- <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
								(click)="onEditSponsors(sponsorsData)"></button>
							<button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
								(click)="onDelete(sponsorsData)"></button> -->
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="summary">
					<div class="p-d-flex p-ai-center p-jc-between">
						In total there are {{AcademyDemoRequestData ? AcademyDemoRequestData.length : 0 }} Academy Demo Request this week.
					</div>
				</ng-template>
			</p-table>
		</div>
	</div>
	<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
</div>